module.exports = __webpack_public_path__ + "img/icone-soil-preparation.b54307e8.svg";